import { config } from '../../config/config.js'


export const getEnvironment = () => localStorage.getItem(config.integrationType + ":environment")

export const setEnvironment = (environment) => {
    localStorage.setItem(config.integrationType + ":environment", environment)
}